export const environment = {
  production: true,
  showCustomDocuments: true,
  disableSentry: false,
}
